import _ from 'lodash';

export const ERRORS = {
  INVALID_EMAIL_OR_PASSWORD: 'You have entered and invalid email or password.',
  ACCOUNT_ALREADY_EXISTS: 'An account with that email address already exists.',
  PASSWORDS_DO_NOT_MATCH: 'The two passwords do not match.',
  USER_NOT_FOUND: 'Invalid username or password',
  PASSWORD_INVALID: 'Invalid username or password',
  '4D_REQUEST_FAILED':
    'Your payment submission encountered a processing error. Please attempt again in 20 minutes.',
  ACH_TRANSACTION_FAILED:
    'Your ACH transaction failed, please verify your routing number, account number, and details.',
  ACH_TRANSACTION_FAILED_UNKNOWN:
    'Your ACH transaction failed with an unknown status. Please report this issue to PRco, referencing code: ',
  BANK_ALREADY_SAVED:
    'You have already saved a bank account with the same name, please delete the saved account or rename this one.',
  NO_DEALER_DATA:
    'There is no dealer account for the specified ID. Please contact PRco for assistance.',
  INVALID_SAGE_RESPONSE:
    'We received an invalid return from our payment provider. Please verify your account details.',
  UNEXPECTED: _.template(
    "An unexpected error has occurred: '<%= message %>' Please contact PRco with your steps so they can fix the issue.",
  ),
};

export const MESSAGES = {
  SUCCESSFULLY_LOGGED_IN: 'You have successfully logged in.',
  PASSWORD_RESET_EMAIL_SENT: 'Check your email for password reset instructions.',
  PAYMENT_SUBMITTED: 'Your payment was submitted to PRCO.',
  '4D_REQUEST_SUCCESSFUL': '4D request was successful with XML result',
  SUCCESSFULLY_ONBOARD: 'Your account information has been saved.',
  ACH_TRANSACTION_SUCCESSFUL: 'Your ACH transaction completed successfully.',
  ACCOUNT_SAVED: 'Your account was saved successfully.',
};

export const API = {
  SAGE: {
    RESPONSE_TYPE_TEXT: {
      APPROVED: 'APPROVED',
      DECLINED: 'DECLINED',
    },
    ERROR: {
      UNKNOWN: 'UNKOWN ERROR',
    },
  },
};
